module.exports = __webpack_public_path__ + "img/logo.6931d5da.png";